import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { DeliveriesList } from './DeliveriesList';

const deliveries = {
  list: DeliveriesList,
  icon: LocalShippingIcon,
};

export default deliveries; 